import React, { useEffect, useState } from 'react'
import { ClubbedAuthModal } from 'src/consumer/components/SignIn/ClubbedAuthComponents'
import { getLoginModalEventName } from 'src/services/axiosInterceptor'

/**
 * Global component that listens for 401-triggered login modal events
 * and displays the ClubbedAuthModal with glassmorphism backdrop
 */
export default function Global401LoginModal() {
  const [showModal, setShowModal] = useState(false)
  const [redirectTo, setRedirectTo] = useState(null)

  /**
   * Validates redirect URL to prevent infinite loops
   */
  const isValidRedirectUrl = (url) => {
    if (!url || typeof url !== 'string') {
      return false
    }
    
    // Prevent redirect to login pages (infinite loop protection)
    const loginPaths = [
      '/login',
      '/workplace/login',
      '/support-home/login',
      '/clinic-home/login',
      '/mentor-home/login',
      '/aumhum-for-clinics',
    ]
    
    const isLoginPage = loginPaths.some(path => url.startsWith(path))
    if (isLoginPage) {
      return false
    }
    
    // Ensure URL is relative (same origin) - prevent open redirects
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) {
      return false
    }
    
    // Ensure URL starts with / (relative path)
    if (!url.startsWith('/')) {
      return false
    }
    
    return true
  }

  useEffect(() => {
    // Listen for 401-triggered login modal event
    const handle401LoginModal = (event) => {
      const redirectUrl = event.detail?.redirectTo || null
      // Validate redirect URL before using it
      const safeRedirectUrl = redirectUrl && isValidRedirectUrl(redirectUrl) 
        ? redirectUrl 
        : null
      setRedirectTo(safeRedirectUrl)
      setShowModal(true)
    }

    const eventName = getLoginModalEventName()
    window.addEventListener(eventName, handle401LoginModal)

    return () => {
      window.removeEventListener(eventName, handle401LoginModal)
    }
  }, [])

  const handleClose = () => {
    setShowModal(false)
    setRedirectTo(null)
  }

  // Note: ClubbedAuthModal handles successful login internally
  // It will redirect using redirectToURI prop or reload the page
  // No need for additional success handler here since the modal
  // handles navigation via window.location.href or window.location.reload()

  return (
    <ClubbedAuthModal
      open={showModal}
      onClose={handleClose}
      loginVariant={true}
      redirectToURI={redirectTo}
      noCloseButton={false}
    />
  )
}

